<div *ngIf="allLoaded" class="container" [ngClass]="{'ionic': useIonic }">
    <!-- Header -->
    <div class="divSeccio header">
        <input type="text" class="searchbox" placeholder="{{ 'SEARCH' | translate }}"
            [(ngModel)]="searchText" />

        <actions *ngIf="!showingSelectedRoutes" [actionstrip]="actions"
            (clickAction)="onClickAction($event)">
        </actions>
        <actions *ngIf="showingSelectedRoutes" [actionstrip]="confirmRoutesActions"
            (clickAction)="onClickAction($event)">
        </actions>
    </div>
    <div class="divSeccio header">
        <span class="explanation" *ngIf="!showingSelectedRoutes">{{
            'BOOKINGPAGE.CONFLICTIVEROUTES.HELP' | translate: {'routesCount': conflictiveRoutes.length}
            }}</span>
        <span class="explanation" *ngIf="showingSelectedRoutes">{{ 'BOOKINGPAGE.CONFIRMRELEASE.HELP'
            | translate: { routesCount: selectedRoutes.length } }}</span>
    </div>

     <!-- Llista rutes conflictives -->
    <div class="divSeccio"
        *ngIf="conflictiveRoutes && conflictiveRoutes.length > 0 && !showingSelectedRoutes">
        <div class="routes">
            <shared-route-item
                *ngFor="let item of conflictiveRoutes | filterActiveRoutes:searchText:filterMetadataRoutes | orderbyroutecarddto:true; let i=index"
                [selected]="selectedRoutes.includes(item.routeId)"
                (click)="onSelectRoute(item)" (dblclick)="onDoubleClickRoute(item)"
                [route]="item">
            </shared-route-item>
        </div>
    </div>

    <div class="divSeccio" *ngIf="showingSelectedRoutes">
        <shared-route-item-list
            *ngFor="let item of getSelectedRoutes() | filterActiveRoutes:searchText:filterMetadataRoutes | orderbyroutecarddto:true; let i=index"
            class="routeItem"
            [route]="item">
        </shared-route-item-list>
    </div>

</div>